import React from "react";
import CardHeader from "./CardHeader";
import * as classNames from "classnames";
import SummaryGraph from "./SummaryGraph";
import moment from "moment";
import "../style.scss";
import { List, Avatar, Card, Button, Table } from "antd";
import StatusTag from "../../Patient/StatusTag";
import EmptyState from "../../Patient/EmptyState";
import EditUserModal from "../../../components/Profile/modal";

const data = [];
const tableColumns = [
  {
    dataIndex: "name",
    key: "name"
  },
  {
    dataIndex: "status",
    key: "status",
    render: (item, record) => <StatusTag data={record} />
  },
  {
    dataIndex: "gender",
    key: "gender"
  },
  {
    dataIndex: "date",
    key: "date",
    render: item => (
      <span>{item ? moment(item).format("DD/MM/YYYY") : undefined}</span>
    )
  },
  {
    dataIndex: "registered",
    key: "registered",
    render: item => <span>{moment(item).format("DD/MM/YYYY")}</span>
  }
];

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  onPatientClicked = id => {
    this.props.push(`/patients/${id}`);
  };
  render() {
    const { user, patients } = this.props;

    const activePatientCount =
      user &&
      user.attributes.activePatientCount &&
      user.attributes.activePatientCount
        ? user.attributes.activePatientCount.toFixed(0)
        : 0;
    const missedTaskCount =
      user && user.attributes.missedTaskCount && user.attributes.missedTaskCount
        ? user.attributes.missedTaskCount
        : 0;
    let patientRows = patients.map((patient, index) => {
      let p = {
        key: patient.id,
        name: `${patient.firstName} ${patient.lastName} `,
        date: patient.birthDate,
        registered: patient.createdAt,
        gender: patient.gender,
        user: {
          attributes: {
            currentSignInAt: patient ? patient.currentSignInAt : undefined
          }
        }
      };

      return p;
    });

    return (
      <div className="dashboard">
        <div className="row no-gutters">
          <div className="col-8 ">
            <Card style={{ height: "175px" }} className="shadow-small">
              <div className="d-flex flex-row">
                <div className="flex-fill mx-1  text-center">
                  <i
                    className="icon icon-task-tick mr-0 muted"
                    style={{ fontSize: "20px" }}
                  />
                  <h1
                    className={classNames("mb-0", {
                      "text-warning": missedTaskCount > 6,
                      "text-danger": missedTaskCount > 10
                    })}
                  >
                    {missedTaskCount}
                  </h1>
                  <div className="muted">Missed Tasks</div>
                </div>
                <div className="flex-fill mx-1 text-center">
                  <i
                    className="icon icon-patient mr-0 muted"
                    style={{ fontSize: "20px" }}
                  />
                  <h1
                    className={classNames("mb-0", {
                      "text-warning": activePatientCount < 80,
                      "text-danger": activePatientCount < 60
                    })}
                  >
                    {activePatientCount}%
                  </h1>
                  <div className="muted">Active Patients</div>
                </div>

                <div className="flex-fill mx-1  text-center">
                  <i
                    className="icon icon-sad mr-0 muted"
                    style={{ fontSize: "20px" }}
                  />
                  <h1 className="mb-0">
                    {user && user.attributes.goalReviewCount
                      ? user.attributes.goalReviewCount
                      : 0}
                  </h1>
                  <div className="muted">Goal Review</div>
                </div>
                <div className="flex-fill mx-1  text-center">
                  <i
                    className="icon icon-inbox mr-0 muted"
                    style={{ fontSize: "20px" }}
                  />
                  <h1 className="mb-0">
                    {user && user.attributes.unreadMessages
                      ? user.attributes.unreadMessages
                      : 0}
                  </h1>
                  <div className="muted">Unread Messages</div>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-4">
            <Card style={{ height: "175px" }} className="shadow-small">
              <CardHeader
                title="Account"
                icon="user"
                buttonTitle="Edit Profile"
                onActionClicked={() => {
                  this.setState({ uniqueKey: Math.random() });
                  this.props.setActiveDialog(`patient-edit-${user.id}`);
                }}
              />

              <div className="d-flex flex-row">
                <div>
                  <label>Signed In As</label>
                  <div>
                    {user
                      ? `${user.attributes.firstName} ${
                          user.attributes.lastName
                        }`
                      : undefined}
                  </div>
                  <label>Organisation</label>
                  <div>
                    {user && user.attributes && user.attributes.accountName}
                  </div>
                </div>
                <div className="justify-content-end text-right flex-fill">
                  <Button onClick={() => this.props.logout()}>Sign Out</Button>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-12">
            <Card className="shadow-small">
              <SummaryGraph {...this.props} />
            </Card>
          </div>
          <div className="col-12 px-3">
            <div className="row no-gutters">
              <div className="col-6">
                <Card className="shadow-small">
                  <CardHeader
                    title="Patients to engage"
                    icon="patient"
                    buttonTitle="View Patients"
                    onActionClicked={() => {
                      this.props.push("patients");
                    }}
                  />
                  <Table
                    columns={tableColumns}
                    dataSource={patientRows.slice(0, 5)}
                    pagination={false}
                    rowClassName="hcs-row clickable"
                    onRow={record => ({
                      onClick: () => {
                        this.onPatientClicked(record.key);
                      }
                    })}
                    locale={{
                      emptyText: <div>No patients available.</div>
                    }}
                  />
                </Card>
              </div>
              <div className="col-6">
                <Card className="shadow-small">
                  <CardHeader
                    title="Inbox"
                    icon="inbox"
                    buttonTitle="View Inbox"
                    onActionClicked={() => {
                      this.props.push("inbox");
                    }}
                  />
                  <List
                    itemLayout="horizontal"
                    locale={{
                      emptyText: "No messages"
                    }}
                    dataSource={data}
                    renderItem={item => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<Avatar icon="user" />}
                          title={<a href="#">{item.title}</a>}
                          description={
                            <div>
                              {item.description}
                              <div className="text-right">
                                <Button>Read Now</Button>
                              </div>
                            </div>
                          }
                        />
                      </List.Item>
                    )}
                  />
                </Card>
              </div>
            </div>
          </div>
        </div>

        <EditUserModal
          key={user.id}
          show={this.props.activeDialog === `patient-edit-${user.id}`}
          onCancel={() => this.props.setActiveDialog()}
          user={user}
          showRole={false}
          userRole={undefined}
          onSave={user => this.props.saveUserRequest(user)}
        />
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard/index.js